import { useState } from "react";

interface Props {
  invoicesLength: number;
  onCycle?: () => void;
}

const useInvoicePaging = ({ invoicesLength, onCycle }: Props) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const cycleInvoices = (increment: number) => {
    onCycle && onCycle();
    const maxPossibleIndex = invoicesLength - 1;
    let newIndex: number = selectedIndex;
    Math.sign(increment) === -1 ? (newIndex -= 1) : (newIndex += 1);
    if (newIndex > maxPossibleIndex) {
      setSelectedIndex(0);
    } else if (newIndex < 0) {
      setSelectedIndex(maxPossibleIndex);
    } else {
      setSelectedIndex(newIndex);
    }
  };

  return { selectedIndex, cycleInvoices };
};

export default useInvoicePaging;
